import { riskAxisLevel, riskScore, riskTreatment } from './format/risk'
import { bool, bytes, date, dateTime } from './format/primitive'
import { apiFormat } from './format/api'

const passthrough = (_table: string | undefined, _field: string, value: string) => value

const lookup: {
	[table: string]: { [field: string]: (table: string | undefined, field: string, value: string) => Promise<string> | string }
} = {
	risks: {
		id: apiFormat,
		is_custom: bool,
		catalog_id: apiFormat,
		category_id: apiFormat,
	},
	risk_meta: {
		id: apiFormat,
		confidentiality: bool,
		integrity: bool,
		availability: bool,
		impact: riskAxisLevel,
		probability: riskAxisLevel,
		accepted_residual_risk: riskScore,
		score: riskScore,
		residual: riskScore,
		last_review: dateTime,
		due_date: date,
		responsible: apiFormat,
		treatment: riskTreatment,
		catalog_meta_id: apiFormat,
		category_meta_id: apiFormat,
	},
	documents: {
		id: apiFormat,
		author_id: apiFormat,
		instance_id: apiFormat,
		length: bytes,
	},
	urls: {
		id: apiFormat,
		author_id: apiFormat,
		instance_id: apiFormat,
		url: passthrough,
	},
}

export async function formatValue(table: string, field: string, value?: string) {
	if (value === undefined || value === null) return ''

	const tbl = lookup[table]
	if (!tbl) return value

	const formatter = tbl[field]
	if (formatter === undefined) return value

	return await formatter(table, field, value)
}
